<template>
  <div class="tq-person-selector-conatiner">
    <tq-person-dialog
      v-model="dialogVisible"
      v-bind="dialogProps"
      :destroy-on-close="isDestroy"
      :append-to-body="appendToBody"
      @closed="onClosed"
    >
      <template #header>
        <span>人员</span>
        <search-area></search-area>
      </template>
      <Layout></Layout>
    </tq-person-dialog>
  </div>
</template>

<script lang="ts" setup>
import TqPersonDialog from './dialog/index.vue'
import type { PersonSelector } from "./types/index";
defineOptions({
  name: "TqPersonSelector",
});

import {
  ref,
  watch,
  provide,
  onBeforeUnmount,
} from "vue";
import type {WatchStopHandle} from 'vue'
import { hookData, hookMethod, reset, getPersonByCodes } from "./hooks/index";
import Layout from "./components/Layout.vue";
import SearchArea from "./components/SearchArea.vue";

type Prosp = {
  visible: boolean;
  codes?: string[] | string;
  isDestroy?: boolean;
  multiple?: boolean;
  appendToBody?: boolean;
  defaultDepartmentId?: string;
};

const props = withDefaults(defineProps<Prosp>(), {
  visible: false,
  codes: "",
  multiple: false,
  isDestroy: false,
  appendToBody: false,
  defaultDepartmentId: "",
});

const emits = defineEmits(["update:visible", "confirm"]);
const dialogVisible = ref<boolean>(false);
const dialogProps = {
  width: "900px",
  "close-on-click-modal": false,
  "close-on-press-escape": false,
};

const unwatchList: WatchStopHandle[] = [];

provide("multiple", props.multiple);
provide("defaultDepartmentId", props.defaultDepartmentId);

hookData.multiple = props.multiple;

hookMethod.onConfirm = (data: PersonSelector.PersonList[]) => {
  emits("confirm", props.multiple ? data : data[0]);
  dialogVisible.value = false;
};

hookMethod.onCancel = () => (dialogVisible.value = false);

const onClosed = () => props.isDestroy && reset();

unwatchList.push(
  watch(
    () => props.visible,
    (val) => {
      dialogVisible.value = val;
      !props.multiple &&
        props.codes &&
        getPersonByCodes(
          Array.isArray(props.codes)
            ? props.multiple
              ? props.codes
              : [props.codes[0]]
            : [props.codes]
        );
    }
  )
);

unwatchList.push(watch(dialogVisible, (val) => emits("update:visible", val)));

unwatchList.push(
  watch(
    () => props.codes,
    (val) =>
      val &&
      getPersonByCodes(
        Array.isArray(val) ? (props.multiple ? val : [val[0]]) : [val]
      ),
    { deep: true }
  )
);

onBeforeUnmount(() => unwatchList.forEach((unwatch) => unwatch()));
</script>

<style>
.tq-dialog .el-dialog .el-dialog__body {
  padding: 0;
}
</style>
